<template>
  <div @click="setModal()">
    <a
        :href="returnLink()"
        class="call-to-action"
    > {{ title }}
    </a>
  </div>
</template>

<script>
export default {
  props: ['title', 'categoria'],
  methods: {
    setModal() {
      if(this.$root.user.id === null) {
        this.$root.isModalShow = !this.$root.isModalShow
      }

      if(this.$root.isModalShow) {
        this.$root.showLogin('/annuncio/pubblica/form/' + this.categoria);
      } else {
        this.$root.closeLogin();
      }
    },

    returnLink() {
      if(!this.$root.user.id) {
        return '#';
      }

      return '/annuncio/pubblica/form/' + this.categoria;
    }
  }
}
</script>

<style>

</style>
